import { Customer, Debt, PaymentType, ProductVersion, Status, Warehouse } from 'models';
import { BaseRecord } from 'types';
import { ETransType, Transaction } from './Transaction';
import { Invoice } from './EInvoice';

// ===================== BASE =====================

export type DiscountUnit = 'PERCENT' | 'VND';

export interface BaseSaleItemDimension {
  dimensions: string;
  quantity: number;
  order: number;
}

export interface BaseSaleOrderItem {
  productVersionId: string;
  saleDimensions?: string;
  quantity: number;
  costPrice: number;
  salePrice: number;
  name?: string;
  category?: string;
  brand?: string;
  productDimension?: string;
  sizeSpec?: string;
  color?: string;
  attributeName?: string;
  attributePrice?: number;
  unit?: string;
  unitId?: string;
  unitConvertValue?: number;
  productVersion?: ProductVersion;
}

export interface BaseSaleOrder {
  code?: string;
  description?: string;
  statusId: string;
  customerId: string | null;
  customerName?: string;
  customerEmail?: string;
  customerPhone?: string;
  customerAddress?: string;
  warehouseId: string;
  memberDiscount?: number;

  discount?: number;
  discountUnit?: DiscountUnit;
  total?: number;
  paymentType?: string;
  deposit?: number;
  depositDate?: Date | string;
  scheduleDate?: Date | string;
  deliveryDate?: Date | string;
  debtDeadline?: Date | string;
  transactions?: {
    transactionMethodId?: string;
    transactionAmount: number;
    transactionAttachments?: {
      attachmentId: string;
      description?: string;
    }[];
    ownerType?: 'CUSTOMER' | 'SUPPLIER';
    type?: ETransType;
  }[];
  Debt?: Debt[];
  vat?: number;
  createdAt?: Date | string | null;
}

// ===================== PAYLOAD =====================

export interface SaleOrderItemPayload extends BaseSaleOrderItem {
  saleItemDimensions?: BaseSaleItemDimension[];
}

export interface SaleOrderPayload extends BaseSaleOrder {
  saleOrderItems?: SaleOrderItemPayload[];
}

// ===================== MODEL =====================

export interface SaleItemDimension extends BaseSaleItemDimension {
  id: string;
  saleOrderItemId: string;
}

export interface SaleOrderItem extends BaseSaleOrderItem {
  id: string;
  saleOrderId: string;
  saleItemDimensions?: SaleItemDimension[];
}

export enum SaleOrderStatusCode {
  PAID = 'so-paid',
  DEBT = 'so-debt',
  DRAFT = 'so-draft',
  CANCELLED = 'so-cancel',
}

export interface SaleOrder extends BaseSaleOrder {
  id: string;
  status?: Status;
  createdBy?: string;
  approvedBy?: string;
  customer?: Customer;
  warehouse: Warehouse;
  paymentType?: PaymentType;
  depositDate?: Date;
  scheduleDate?: Date;
  deliveryDate?: Date;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  saleOrderItems?: SaleOrderItem[];
  Transactions?: Transaction[];
  paidAmount?: number;
}
export interface SaleOrderRecord extends BaseRecord<unknown> {
  id: string;
  code: string;
  customerName: string;
  createdAt: Date;
  'status.code': string;
  total: number;
  paidAmount: number;
}
export interface SaleOrderResponse {
  statusCode: string;
  success: boolean;
  data: SaleOrder;
}
export interface BillResponse {
  statusCode: string;
  success: boolean;
  data: {
    filePath: string;
    fileUrl: string;
  };
}

export type InvoiceProviderResponse = {
  errorCode: number;
  message: string;
  data: {
    errorCode: number;
    message: string;
    data: {
      khmshDon: string;
      khhDon: string;
      maTraCuu: string;
      mtChieu: string;
      shDon: number;
      maSoHDon: string;
      nLap: string;
      urlDownloadPDF: string;
      urlDownloadXML: string;
    };
    success: boolean;
  }[];
  success: boolean;
};
export interface EInvoiceResponse {
  statusCode: string;
  success: boolean;
  data: {
    status: string;
    providerInvoice: InvoiceProviderResponse;
    invoice: Invoice;
  };
}
